import React from "react";
import MainTitle from "../Common/MainTitle";
import AboutAsia from "../../assets/images/AboutAsia.png";

function SectionAboutConsultancy() {
  return (
    <>
      <div className="container pt-4 mb-4">
        {/* <div className="d-flex justify-content-center"> */}
          <MainTitle text="About South Asia Consultancy" className={'text-center'} position={'center'} width={'171px'}/>
        {/* </div> */}
        <div className="row pt-2">
          <div className="col-md-6">
            <p className="text-justify">
              South Asia Consultancy is an ISO 9001 certified company with
              headquarter in Ahmedabad, Gujarat, providing oilfield services.
              SAC was established in 2014 by its sole proprietor Mr. D S Rajput
              to supply quality manpower to Oil & Gas companies worldwide. SAC
              began providing Operation & Maintenance Services for various
              Oilfield activities including Drilling, Workover etc. in onshore
              as well as offshore and today, SAC is considered as one of the
              leading company providing Oil and Gas Services. SAC has supplied
              quality manpower to Manage Jack-up Drilling Rigs in the Persian
              Gulf and successfully executed the contracts. SAC has vast
              experience in managing onshore and offshore drilling rigs up to
              3000 HP capacity, Amphion and Cyberbase control, and as latest as
              7th generation rigs of reputed make like NOV, Drillmec,
              LeTourneau, Romania etc. With objective of monetizing discovered
              small Oil and Gas Field to boost domestic oil and gas production,
              Govt. of India has awarded South Patan Field to South Asia
              Consultancy through DSF-2016 Bidding Round, and SAC entered into
              the upstream Oil and Gas Exploration and Production Sector. South
              Patan Oilfeld is in Cambay Basin, Gujarat. SAC seeks to enhance
              its worldwide position in its market niche through continued focus
              on quality service. SAC seeks to create a Global Energy leader
              that responsibly caters to energy demand.
            </p>
          </div>
          <div className="col-md-6">
            <img src={AboutAsia} className="img-fluid" alt="About" />
          </div>
        </div>
      </div>
    </>
  );
}

export default SectionAboutConsultancy;
